import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import { Actions } from 'components/Actions';

export const useColumns = (refetch: () => void) =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Notifications',
        columns: [
          {
            Header: 'Season',
            accessor: 'season',
          },
          {
            Header: 'Season Line',
            accessor: 'seasonLine',
          },
          {
            Header: 'Title (IT)',
            accessor: 'title.it',
          },
          {
            Header: 'Title (EN)',
            accessor: 'title.en',
          },
          {
            Header: 'Status',
            accessor: 'status',
          },
          {
            Header: 'Published',
            accessor: 'isPublished',
            Cell: ({ value }) => <span>{value ? '✓' : '✗'}</span>,
          },
          {
            accessor: 'action',
            disableSortBy: true,
            Cell: ({ row }) => (
              <Actions
                isManagePath
                hasDelete
                toTheRight
                id={row.original.id}
                rowData={row.original}
                refetch={refetch}
                tableName="notifications"
              />
            ),
          },
        ],
      },
    ],
    [refetch]
  );
